import { render } from "./OrderDetail.vue?vue&type=template&id=30ef9cd6"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=30ef9cd6&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__